// extracted by mini-css-extract-plugin
export default {"templatesBox":"MessageTemplates_templatesBox__rj0Jq","templateCard":"MessageTemplates_templateCard__m8ssa","rotateIcon":"MessageTemplates_rotateIcon__qUslF"};